export default "__VITE_ASSET__CUMrmowb__"